import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import { withRouter } from 'react-router-dom';

import Spinner from "@sm/components/Spinner";
import Table from "@sm/components/custom/Table";

import "@assets/css/apiData.css";

import { DASHBOARD_SETTLEMENTS } from "@sm/actions/types";
import { toFormattedNumber } from "@sm/utils/utils";
import { DATA_TYPES } from "@modules/data/ManualInput";
const store = require("@sm/reducers/index");

class DashBoardSettlementsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settlements: undefined,
      loading: true,
      socket: false,

      columns: [
        {
          value: "requestDate",
          label: "Date",
          isNumber: false,
          isDate: true,
          leftAligned: true,
        },
        {
          value: "merchantName",
          label: "Merchant",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "amount",
          label: "Amount",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "fxPair",
          label: "FX Pair",
          isNumber: false,
          rightAligned: true,
        },
        {
          value: "fxRate",
          label: "FX Rate",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "id",
          label: "Action",
          centerAligned: true,
          className: "btn view-settlement",
          buttonLabel: "View",
          isButton: true,
          triggerEvent: (data) => this.viewSettlement(data),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        }
      ],

      otcColumns: [
        {
          value: "requestDate",
          label: "Date",
          isNumber: false,
          isDate: true,
          leftAligned: true,
        },
        {
          value: "merchantName",
          label: "Merchant",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "amount",
          label: "Amount",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "fxPair",
          label: "FX Pair",
          isNumber: false,
          rightAligned: true,
        },
        {
          value: "fxRate",
          label: "FX Rate",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "settlement",
          label: "Settlement",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "id",
          label: "Action",
          centerAligned: true,
          className: "btn view-settlement",
          buttonLabel: "View",
          isButton: true,
          triggerEvent: (data) => this.viewSettlement(data),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        }
      ],
    };
  }

  subscribeFunction = null;

  componentDidMount() {
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true,
        });
      }

      if (
        state.update === DASHBOARD_SETTLEMENTS &&
        this.props.thisMonth &&
        state.settlements.socket
      ) {
        this.setState({
          settlements: state.settlements,
          loading: false,
          socket: state.settlements.socket,
        });
        return;
      }

      if (state.update === DASHBOARD_SETTLEMENTS && !state.settlements.socket) {
        this.setState({
          settlements: state.settlements,
          loading: false,
          socket: state.settlements.socket,
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  }

  tableData = () => {
    const { settlements } = this.state;

    if (!settlements) {
      return [];
    }

    return settlements.map((elem) => {
      return {
        id: elem.id,
        merchantName: elem.merchantName,
        amount: toFormattedNumber(elem.amount),
        merchantId: elem.merchantId,
        currency: elem.currency,
        requestDate: elem.requestDate,
        fxPair: elem.fxPair,
        fxRate: toFormattedNumber(elem.fxRate),
        settlement: toFormattedNumber(elem.settlement),
        otc: elem.otc
      };
    });
  };

  viewSettlement = (data) => {
    this.props.history.push({
      pathname: data.otc ? "/otc-settlements" : "/manual-input",
      state: {
        ...data,
        dataType: data.otc ? DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST : DATA_TYPES.SETTLEMENT_BY_REQUEST
      }
    });
  };

  render() {
    const { settlements, loading, columns, otcColumns } = this.state;
    const { isOtcEnabled } = this.props;

    let sellsWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> PENDING SETTLEMENT REQUESTS </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && settlements) {
      sellsWrap = (
        <Panel style={ { height: "100%" } }>
          <Panel.Heading>
            <Panel.Title> PENDING SETTLEMENT REQUESTS </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content ">
              <Table
                columns={ isOtcEnabled ? otcColumns : columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
                isStriped={ false }
                defaultSortBy="requestDate"
                sortDirection="DESC"
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return sellsWrap;
  }
}

export default withRouter(DashBoardSettlementsComponent);
